import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Button from "components/CustomButton/CustomButton.jsx";
import {
  searchLeadForOrder,
  getFlashCreditTypes,
  RemoveFlashCredits,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";

class removeFlashCredit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      note_title: "",
      note_titleError: null,
      credit_type_err: null,
      credit_type: null,
      creditTypeList: [],
      note_description: "",
      note_descriptionError: null,
      user_id: "",
      user_idError: null,
      points: "",
      pointsError: null,
      subscriberItems: [],
      subscribername: "",
      loading: true,
      _notificationSystem: null,
      cardHidden: true,
      processing: true,
      //   is_flash_voucher: 0,
      org_id: null,
    };
    this.onChange = this.onChange.bind(this);
    this.onRemoveFlashCredit = this.onRemoveFlashCredit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }
  inputOnChangeSubscriber = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      subscribername: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParentSubscriber(self.state.subscribername);
      }, 300),
    });
  };
  sendToParentSubscriber = async () => {
    if (this.state.subscribername.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var city_id = this.state.city_id;
      await searchLeadForOrder(this.state.subscribername, obj).then((res) => {
        const data = res.data.data;
        let subscriberItems = [];
        res.data.data.map((x, i) => {
          subscriberItems.push({
            value: x.id,
            label: x.name + " (" + x.mobile_no + ")",
            org_id: x.organization_id,
          });
        });

        this.setState({
          subscriberItems: subscriberItems,
        });
      });
    } else {
      this.setState({
        subscriberItems: [],
      });
    }
  };
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Credit</b> - Removed Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    getFlashCreditTypes(obj).then((cdata) => {
      const flashCreditTypes = cdata.data;
      this.setState({
        creditTypeList: flashCreditTypes,
      });
    });
  }
  onSubscriberChange = (value) => {
    this.setState({
      user_id: value.value,
      org_id: value.org_id,
    });
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  onRemoveFlashCredit = () => {
    let error = false;

    if (this.state.user_id == "") {
      error = true;
      this.setState({
        user_idError: (
          <small className="text-danger">User name is required..</small>
        ),
      });
    } else {
      this.setState({ user_idError: null });
    }
    if (this.state.points.length == 0) {
      error = true;
      this.setState({
        pointsError: (
          <small className="text-danger">Credit is required..</small>
        ),
      });
    } else {
      this.setState({ pointsError: null });
    }
    if (this.state.credit_type == "0" || this.state.credit_type == null) {
      error = true;
      this.setState({
        credit_type_err: (
          <small className="text-danger">Credit Type is required..</small>
        ),
      });
    } else {
      this.setState({ credit_type_err: null });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      this.setState({ processing: false }, () => {
        this.setState({ loading: true }, () => {
          RemoveFlashCredits(
            this.state.user_id,
            this.state.points,
            "Reset Balance",
            this.state.credit_type,
            "Clears the claim wallet balance",
            // this.state.is_flash_voucher,
            this.state.org_id,
            obj
          )
            .then((res) => {
              if (res.data.success === false) {
                this.handleClick("bl");
                this.setState({ processing: true });
              } else if (res.data.success === true) {
                this.setState({ processing: true });
                this.setState({
                  loading: false,
                  user_id: "",
                  points: "",
                  credit_type: "",
                  note_title: "",
                  note_description: "",
                  subscriberItems: [],
                });
                this.handleSuccess("bl");
                setTimeout(window.location.reload(), 2000);
              }
            })
            .catch((error) => {
              this.handleNetworkError("bl");
              console.log(error, "== error");
            });
        });
      });
    }
  };
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel>User Name</ControlLabel>
                          <div
                            onKeyUp={(e) => this.inputOnChangeSubscriber(e)}
                            className="Appy2"
                          >
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="user_id"
                              // value={this.state.user_id}
                              onChange={(value) =>
                                this.onSubscriberChange(value)
                              }
                              options={this.state.subscriberItems}
                              placeholder="Select User"
                              noOptionsMessage={() =>
                                "Type Name or Phone Number"
                              }
                            />
                          </div>
                          {this.state.user_idError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Credits</ControlLabel>
                          <FormControl
                            name="points"
                            value={this.state.points}
                            onWheel={(e) => e.target.blur()}
                            onChange={(event) => {
                              this.setState({ points: event.target.value });
                              event.target.value === ""
                                ? this.setState({
                                    pointsError: (
                                      <small className="text-danger">
                                        Credit is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ pointsError: null });
                            }}
                            placeholder="Enter Credit"
                            type="number"
                          />
                          {this.state.pointsError}
                        </FormGroup>
                        <ControlLabel>Credit Type</ControlLabel>
                        <FormGroup>
                          <select
                            name="credit_type"
                            value={this.state.credit_type}
                            onChange={(event) => {
                              this.setState({
                                credit_type: event.target.value,
                              });
                              event.target.value == "0"
                                ? this.setState({
                                    credit_type_err: (
                                      <small className="text-danger">
                                        Credit type is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ credit_type_err: null });
                            }}
                            className="form-control"
                            placeholder="Credit Type"
                          >
                            <option value="0">Select Credit Type</option>
                            {this.state.creditTypeList &&
                              this.state.creditTypeList.map((creditType) => (
                                <option value={creditType.id}>
                                  {creditType.title}
                                </option>
                              ))}
                          </select>
                          {this.state.credit_type_err}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Note Title</ControlLabel>
                          <FormControl
                            name="note_title"
                            value={this.state.note_title}
                            onChange={(event) => {
                              this.setState({ note_title: event.target.value });
                            }}
                            placeholder="Enter Note Title"
                            type="text"
                          />
                          {this.state.note_titleError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Note Description</ControlLabel>
                          <FormControl
                            name="note_description"
                            value={this.state.note_description}
                            onChange={(event) => {
                              this.setState({
                                note_description: event.target.value,
                              });
                            }}
                            placeholder="Enter Note Description"
                            type="text"
                          />
                          {this.state.note_descriptionError}
                        </FormGroup>
                        {/* <FormGroup>
                          <Checkbox
                            number="69"
                            checked={this.state.is_flash_voucher}
                            onChange={(event) =>
                              this.setState({
                                is_flash_voucher: event.target.checked,
                              })
                            }
                            label="Is Voucher?"
                          ></Checkbox>
                        </FormGroup> */}
                      </Col>
                    </Row>

                    <Button
                      disabled={!this.state.processing}
                      onClick={this.onRemoveFlashCredit.bind(this)}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Remove
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default removeFlashCredit;
